export * from './lib/hosted-auth';
export * from './lib/products';
export * from './lib/account-profile.mapping';

export { default as LinkedinIcon } from './lib/icon.svg';

export const linkedinName = 'LinkedIn';
